<template>
  <v-navigation-drawer
    app
    v-model="$store.state.layout.drawer"
    :temporary="$vuetify.breakpoint.smAndDown"
    :width="248"
    class="admin-drawer"
    id="app-drawer"
  >
    <v-sheet
      height="64"
      class="admin-drawer__brand d-flex justify-center align-center px-5"
    >
      <v-img contain :src="brandConfig.logos.inline" height="35" />
     
      
    </v-sheet>

    <!-- 🔹 Navigation -->
    <v-list nav class="admin-drawer__nav px-3 py-4">
      <template v-for="(item, index) in items">
        <v-subheader v-if="item.header" :key="index" class="admin-drawer__section px-3 mt-3">
          <v-row no-gutters class="align-center">
            <v-col>{{ item.header }}</v-col>
            <v-spacer />
            <v-col v-if="item.header === 'Overview'" cols="auto" class="text-caption admin-muted">
              {{ version }}
            </v-col>
          </v-row>
        </v-subheader>

        <!-- ▪ Divider -->
        <v-divider v-else-if="item.divider" />

        <!-- ▪ List Group (with children) -->
        <v-list-group
          v-else-if="item.items"
          :prepend-icon="item.icon"
          no-action
        >
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

          <!-- ▪ Sub-items -->
          <template v-for="(subItem, i) in item.items">
            <v-list-group
              :key="i"
              v-if="subItem.items"
              sub-group
              :prepend-icon="subItem.icon"
            >
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{ subItem.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list-group>

            <!-- ▪ Sub-item (leaf) -->
            <v-list-item
              v-else
              :key="`subitem-${i}`"
              :to="!subItem.href ? { path: subItem.path } : null"
              :href="subItem.href"
              :target="subItem.target"
              :disabled="subItem.disabled"
              rel="noopener"
            >
              <v-list-item-content>
                <v-list-item-title>{{ subItem.title }}</v-list-item-title>
              </v-list-item-content>

              <v-chip
                v-if="subItem.badge"
                small
                label
                class="white--text pa-0 v-chip--x-small"
                :color="subItem.color || 'primary'"
              >
                {{ subItem.badge }}
              </v-chip>

              <v-list-item-action v-if="subItem.action">
                <v-icon :class="[subItem.actionClass || 'success--text']">
                  {{ subItem.action }}
                </v-icon>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list-group>

        <!-- ▪ Single Item -->
        <v-list-item
          v-else
          :to="!item.href ? { path: item.path } : null"
          :href="item.href"
          :disabled="item.disabled"
          :target="item.target"
          rel="noopener"
        >
          <v-list-item-action v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>

          <v-chip
            v-if="item.badge"
            small
            label
            class="white--text pa-0 v-chip--x-small"
            :color="item.color || 'primary'"
          >
            {{ item.badge }}
          </v-chip>

          <v-list-item-action v-if="item.subAction">
            <v-icon class="success--text">{{ item.subAction }}</v-icon>
          </v-list-item-action>

          <v-chip
            v-else-if="item.chip"
            small
            label
            class="caption blue lighten-2 white--text mx-0"
          >
            {{ item.chip }}
          </v-chip>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
const pjson = require("../../../../package.json");

export default {
  name: "AppDrawer",
  data() {
    return {
      isStoreSync: false,
      items: [],
    };
  },
  computed: {
    ...mapGetters("integration", ["modules"]),
    ...mapGetters("brand", ["currentBrand", "brandConfig"]),
    version() {
      return pjson.version;
    },
  },
  mounted() {
    this.detectBrand();
    this.loadNav();
  },
  methods: {
    detectBrand() {
      const host = window.location.hostname.toLowerCase();
      if (host.includes("storesyncpos")) this.isStoreSync = true;
      else if (host.includes("autorepairdesk")) this.isStoreSync = false;
      else this.isStoreSync = true; // default
    },

    loadNav() {
      this.items = [
        {
          title: "Home",
          icon: "mdi-home-outline",
          path: "/",
        },
        {
          title: this.$t("sideBar.locations"),
          icon: "mdi-store-outline",
          path: "/location",
        },
        {
          title: this.$t("sideBar.employees"),
          icon: "mdi-account-group-outline",
          path: "/employee/list",
        },
        {
          title: "Day End",
          icon: "mdi-calendar-check-outline",
          path: "/dayEnd/list",
        },
        {
          title: this.$t("sideBar.reports"),
          icon: "mdi-chart-box-outline",
          path: "/reports",
        },
        {
          title: this.$t("sideBar.settings"),
          icon: "mdi-cog-outline",
          path: "/settings",
        },
      ];
    },
  },
};
</script>
